import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router";

import ImageEditorPage from "../../Detalj/ImageEditorPage";

import {
  getIleggelseBildeBase64,
  postIleggelserBilder,
} from "../../../../actions/ileggelserActions";

export default function IleggelseImageEditorPageContainer() {
  const { id: ileggelseId, bildeId } = useParams();
  const dispatch = useDispatch();

  const getBilde = useCallback(
    () => dispatch(getIleggelseBildeBase64(ileggelseId, bildeId)),
    [dispatch, ileggelseId, bildeId],
  );
  const handlePostBilder = useCallback(
    (_unused, file) =>
      dispatch(postIleggelserBilder(ileggelseId, file, true, true)),
    [dispatch, ileggelseId],
  );

  return (
    <ImageEditorPage
      getBilde={getBilde}
      postIleggelserBilder={handlePostBilder}
    />
  );
}
